import React from 'react';
import { ArrowRight, Shield, Globe, Heart } from 'lucide-react';
import { Button } from './ui/button';
import { stats } from '../mock';

export const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1601375461807-d377395b5eb9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxwZXQlMjB0cmF2ZWx8ZW58MHx8fHwxNzczMjc4MTMwfDA&ixlib=rb-4.1.0&q=85"
          alt="Pet Travel"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 to-white/60"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-primary/10 border border-primary/20 rounded-full px-4 py-2 mb-6">
            <Globe className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-primary">Cayman Islands-Based Pet Travel Experts</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight mb-6">
            Your Pet's Journey,
            <span className="text-primary"> Our Priority</span>
          </h1>

          {/* Subheading */}
          <p className="text-base sm:text-lg text-foreground/70 mb-8 leading-relaxed">
            With over 12 years of expertise in pet travel compliance, we guarantee stress-free travel experiences for you and your furry family members. Based in the Cayman Islands, we specialize in pet relocation, imports, visitor pet services, and vacation travel assistance.
          </p>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center gap-6 mb-10">
            <div className="flex items-center gap-2">
              <Shield className="w-5 h-5 text-primary" />
              <span className="text-sm font-medium text-foreground/70">12+ Years Experience</span>
            </div>
            <div className="flex items-center gap-2">
              <Heart className="w-5 h-5 text-primary" />
              <span className="text-sm font-medium text-foreground/70">Hundreds of Pets Assisted</span>
            </div>
            <div className="flex items-center gap-2">
              <Globe className="w-5 h-5 text-primary" />
              <span className="text-sm font-medium text-foreground/70">Access to 80+ Global Partners</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <Button 
              size="lg"
              onClick={() => scrollToSection('contact')}
              className="bg-primary hover:bg-primary/90 text-white group"
            >
              Schedule Consultation
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button 
              size="lg"
              variant="outline"
              onClick={() => scrollToSection('how-it-works')}
              className="border-secondary text-secondary hover:bg-secondary hover:text-white"
            >
              How It Works
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
